module.exports = __webpack_public_path__ + "static/assets/4c3354f5536cc0d79df7350b80aa3ef1.png";